import { useAdminPaywallCharge } from "@circle-react/hooks/paywalls/useAdminPaywallCharge";
import {
  allFilterTranslations,
  normalizeFilters,
} from "../../Filters/useFilters";
import { TABS, TABS_LOCALE, type TabType, statusByTab } from "../constants";

interface UseTabWithFiltersProps {
  resetAllChargesToFirstPage: () => void;
  setActiveFilterTab: (tab: TabType) => void;
  setSearchKey: (key: string) => void;
}

export const useTabWithFilters = ({
  setActiveFilterTab,
  setSearchKey,
  resetAllChargesToFirstPage,
}: UseTabWithFiltersProps) => {
  const allChargesData = useAdminPaywallCharge({
    filters: normalizeFilters(
      { status: statusByTab[TABS.ALL] },
      allFilterTranslations.charges,
    ),
    perPage: 1,
    page: 1,
    setPage: () => {},
  });
  const paidChargesData = useAdminPaywallCharge({
    filters: normalizeFilters(
      { status: statusByTab[TABS.PAID] },
      allFilterTranslations.charges,
    ),
    perPage: 1,
    page: 1,
    setPage: () => {},
  });
  const processingChargesData = useAdminPaywallCharge({
    filters: normalizeFilters(
      { status: statusByTab[TABS.PROCESSING] },
      allFilterTranslations.charges,
    ),
    perPage: 1,
    page: 1,
    setPage: () => {},
  });
  const refundedChargesData = useAdminPaywallCharge({
    filters: normalizeFilters(
      { status: statusByTab[TABS.REFUNDED] },
      allFilterTranslations.charges,
    ),
    perPage: 1,
    page: 1,
    setPage: () => {},
  });
  const failedChargesData = useAdminPaywallCharge({
    filters: normalizeFilters(
      { status: statusByTab[TABS.FAILED] },
      allFilterTranslations.charges,
    ),
    perPage: 1,
    page: 1,
    setPage: () => {},
  });

  const tabOptions = [
    [TABS.ALL, allChargesData] as const,
    [TABS.PAID, paidChargesData] as const,
    [TABS.PROCESSING, processingChargesData] as const,
    [TABS.REFUNDED, refundedChargesData] as const,
    [TABS.FAILED, failedChargesData] as const,
  ].map(([tab, chargesData]) => ({
    value: tab,
    label: TABS_LOCALE[tab],
    badge: { value: chargesData.totalCharges },
  }));

  const changeTabAndResetForm = (tab: TabType) => {
    setSearchKey("");
    setActiveFilterTab(tab);
    resetAllChargesToFirstPage();
  };

  return {
    tabOptions,
    changeTabAndResetForm,
  };
};
